import { domReady } from "../utils";

const digits = (s) => String(s ?? "").replace(/\D/g, "").slice(0, 8);
const up = (s) => String(s ?? "").trim().toUpperCase();
const debounce = (fn, wait = 300) => { let t; return function (...a) { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), wait); }; };

function selectStateByEstado(estado) {
  const target = up(estado);
  let id = null;
  $("#state_id option").each(function () {
    const $o = $(this);
    if ([up($o.data("estado")), up($o.val()), up($o.text())].includes(target)) {
      id = $o.val();
      return false; // break
    }
  });
  if (id) $("#state_id").val(id);
  return id;
}

function loadCities(stateId, preferredCity) {
  const $city = $("#city_id");
  if (!$city.length) return;

  $city.prop("disabled", true).html(`<option value="">Carregando...</option>`);

  $.getJSON(`/api/v1/searches/cities?q[state_id_eq]=${encodeURIComponent(stateId)}`)
    .done(({ cities = [] }) => {
      const pref = up(preferredCity);
      let html = `<option value="">Selecione a Cidade</option>`;
      let preId = "";

      for (const c of cities) {
        const id = String(c.id);
        const name = String(c.name || "");
        const isPref = pref && up(name) === pref;
        if (isPref) preId = id;
        html += `<option value="${id}"${isPref ? " selected" : ""}>${name}</option>`;
      }

      $city.html(html).prop("disabled", false);
      if (preId) $city.val(preId);
    })
    .fail(() => {
      $city.html(`<option value="">Selecione a Cidade</option>`).prop("disabled", false);
    });
}

function onCepInput() {
  const cep8 = digits($(this).val());
  if (cep8.length !== 8) return;

  $.getJSON(`https://viacep.com.br/ws/${cep8}/json/`).done((data) => {
    if (data?.erro) return;

    $(".neighborhood_search").val(data.bairro || "");
    $(".street_search").val(data.logradouro || "");

    const estado = up(data.estado);
    const stateId = estado ? selectStateByEstado(estado) : null;
    if (stateId) loadCities(stateId, data.localidade);
  });
}

const verifyZipCode = () => {
  $(document).on("input", ".cep_search", debounce(onCepInput, 300));
};

export default domReady(verifyZipCode);



// import { domReady } from "../utils";

// const verifyZipCode = () => {
//   $('.cep_search').keyup(function () {
//     const cep = $(this).val()
//     console.log("Search cep")
//     if (cep.length == 9) {
//       $.get("https://api.carhoo.com.br/find_by_cep/" + cep, {}, function (data) {
//         if (data != 0) {
//           $('.neighborhood_search').val(data.bairro)
//           $('.street_search').val(data.street)
//           $('.state_search').val(data.state)
//           $('.city_search').val('')
//           $('.city_search').html('')
//           $('.city_search').append("<option value=\"\">Selecione a Cidade</option>")
//           data.cities.forEach(function (element) {
//             var newOption = new Option(element.name, element.id, false, false);
//             // Append it to the select
//             $('.city_search').append(newOption)
//           });
//           $('.city_search').val(data.city)
//         } else {
//           console.log('cep error')
//         }
//       })
//     }
//   });
// }

// export default domReady(verifyZipCode);
